import appSettings from 'wanderu-config';
import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';
import WapiService from 'wanderu-service-wapi';

import {
    actions as policiesActions,
} from '../../appstate';
import {
    namespace,
    actions,
    reducer,
    selectors,
} from './base';

const logger = Logger.getLogger('wanderu-ducks-carriers:fetchAllPolicies');

function fetch() {
    return async (dispatch) => {
        dispatch(actions.startWork());

        let error;

        try {
            const response = await WapiService.get('carriers/policies');

            if (!response?.result) {
                throw new Error('no policies found');
            }

            dispatch(policiesActions.setAllPolicies(response?.result));
        } catch (ex) {
            const domainUserInfo = appSettings.env.isClient
                ? SnowplowService.getDomainUserInfo()
                : {};

            logger.warn('fetch', ex, {
                snowplowIds: {
                    networkUserId: SnowplowService.getNetworkUserId(),
                    ...domainUserInfo,
                },
            });

            error = {
                message: ex.message,
            };
        } finally {
            dispatch(actions.endWork(undefined, undefined, error));
        }
    };
}

const fetchAllPoliciesAction = {
    fetch,
    ...selectors,
};

export {
    fetchAllPoliciesAction,
};

export default {
    [namespace]: reducer,
};
